import React from 'react';
import './App.css'
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import SideBar from './Components/SideBar';
import Home from './Pages/Home';
import Customerlist from './Pages/Customerlist';
import OrderList from './Pages/OrderList';
import OrderDetails from './Pages/OrderDetails';
import EstimateList from './Pages/EstimateList';
import EstimateDetails from './Pages/EstimateDetails';
import RetailOrderDetails from './Pages/RetailOrderDetails';
// import GstBillDetails from './Pages/GstBillDetails';
import BannerList from './Pages/BannerList';
import AddBanner from './Pages/AddBanner';
import EditOrderDetails from './Pages/EditOrderDetails';
import EditEstimateDetails from './Pages/EditEstimateDetails';
import EditRetailOrderDetails from './Pages/EditRetailOrderDetails';
// import Maincategory from './Pages/Maincategory';
// import AddMaincategory from './Pages/AddMaincategory';
// import SubCategory from './Pages/SubCategory';
// import AddSubcategory from './Pages/AddSubcategory';
import Products from './Pages/Products';
import AddProducts from './Pages/AddProducts';
import AddRetailProduct from './Pages/AddRetailProduct';
import Login from './Components/Login';
import Settings from './Components/Settings';
import Users from './Components/Users';
import Previlage from './Components/Previlage';
import Addusers from './Components/Addusers';
import Stock from './Pages/Stock';
import Brand from './Pages/Brand';
import AddBrand from './Pages/AddBrand';
import CanceOrder from './Pages/CanceOrder';
import CancelOrderDetails from './Pages/CancelOrderDetails';
// import EditMaincategory from './Pages/EditMaincategory';
// import EditSubcategory from './Pages/EditSubcategory';
import EditProducts from './Pages/EditProducts';
import EditRetailProduct from './Pages/EditRetailProduct';
import EditBillDate from './Pages/EditBillDate';
import EditBrand from './Pages/EditBrand';
import Content from './Components/Content';
import ContentEdit from './Components/ContentEdit';
import ViewCustomer from './Pages/ViewCustomer';
import Editusers from './Components/Editusers';
import Invoice from './Pages/Invoice';
import EstimateInvoice from './Pages/EstimateInvoice';
import Pos from './Pages/Pos';
import Estimate from './Pages/Estimate';
import PosRetailAdd from './Pages/PosRetailAdd';
// import GstBill from './Pages/GstBill';
// import GstBillList from './Pages/GstBillList';
import CustomOrderList from './Pages/CustomOrderLIst';
import CustomOrderDetails from './Pages/CustomOrderDetails';
import EditBanner from './Pages/EditBanner';
import Footer from './Components/Footer'
import PaymenyPending from './Pages/PaymenyPending';
import RetailProduct from './Pages/RetailProduct';
import RetailPOS from './Pages/RetailPOS';
import SupplierPending from './Pages/SupplierPending';

import PaidReport from './Pages/PaidReport';
import PaidReportSupplier from './Pages/PaidReportSupplier';
import PaidPrint from './Pages/PaidPrint';
import PaidPrintSupplier from './Pages/PaidPrintSupplier';
import PurchaseList from './Pages/PurchaseList';
import AddPurchase from './Pages/AddPurchase';
import EditPurchase from './Pages/EditPurchase';
import ImportProducts from './Components/ImportProducts';
import ImportRetailProduct from './Components/ImportRetailProduct';
import ImportCustomer from './Pages/ImportCustomer';
import AddCustomer from './Pages/AddCustomer';
import GstReport from './Pages/GstReport';
import GstReportPurchase from './Pages/GstReportPurchase';
import { matchPath } from 'react-router-dom';
import Unit from './Pages/Unit';
import AddUnit from './Pages/AddUnit';
import EditUnit from './Pages/EditUnit';
import Supplier from './Pages/Supplier';
import PaymentDetails from './Pages/PaymentDetails';
import AddPaymentDetails from './Pages/AddPaymentDetails';
import AddSupplier from './Pages/AddSupplier';
import EditSupplier from './Pages/EditSupplier';
import PurchaseDetails from './Pages/PurchaseDetails';
import UpdateList from './Pages/UpdateList';
import UpdateRetailList from './Pages/UpdateRetailList';

const AppLayout = () => {
    const location = useLocation();
     const isEditOrderDetails = matchPath("/editorderdetails/:order_id", location.pathname);
     const isEditEstimateDetails = matchPath("/editestimatedetails/:order_id", location.pathname);
     const isEditRetailOrderDetails = matchPath("/editretailorderdetails/:order_id", location.pathname);
    const isLoginPage = location.pathname === '/login';
    const isInvoicePage = matchPath("/invoice/:order_id", location.pathname);
    const isInvoiceEstimatePage = matchPath("/estimate_invoice/:order_id", location.pathname);
    const ispaidPrint = matchPath("/paidprint/:order_id/:paid_id", location.pathname);
    const ispaidPrintSupplier = matchPath("/paidprintsupplier/:purchase_id/:paid_id", location.pathname);
    const isPosPage = location.pathname === "/pos";
    const isEstimatePage = location.pathname === "/estimate";
    const isPosRetailAddPage = location.pathname === "/posretailadd"; 

    return (
        <div>
            {!isLoginPage &&!isEditEstimateDetails &&!isInvoiceEstimatePage &&!isEstimatePage &&!isPosRetailAddPage &&!isEditRetailOrderDetails &&!isEditOrderDetails &&!ispaidPrintSupplier &&!isPosRetailAddPage &&!ispaidPrint  &&!isInvoicePage && !isPosPage  &&  <SideBar />}
            <Routes>
                <Route path="/" element={<Navigate to="/login" />} />
                <Route path="/login" element={<Login />} />
                <Route path="/home" element={<Home />} />
                <Route path="/customerlist" element={<Customerlist />} />
                <Route path="/orderlist" element={<OrderList />} />
                <Route path="/estimatelist" element={<EstimateList />} />
                <Route path="/orderdetails/:order_id" element={<OrderDetails />} />
                 <Route path="/editorderdetails/:order_id" element={<EditOrderDetails />} />
                <Route path="/estimatedetails/:order_id" element={<EstimateDetails />} />
                 <Route path="/editestimatedetails/:order_id" element={<EditEstimateDetails />} />
                 <Route path="/retailorderdetails/:order_id" element={<RetailOrderDetails />} />
                 <Route path="/editretailorderdetails/:order_id" element={<EditRetailOrderDetails />} />
                {/* <Route path="/gstbilldetails/:order_id" element={<GstBillDetails />} /> */}
                <Route path="/bannerlist" element={<BannerList />} />
                <Route path="/addbanner" element={<AddBanner />} />
                <Route path="/editbanner/:banner_id" element={<EditBanner />} />
                {/* <Route path="/maincategory" element={<Maincategory />} /> */}
                {/* <Route path="/addmaincategory" element={<AddMaincategory />} /> */}
                {/* <Route path="/subcategory/:category_id" element={<SubCategory />} /> */}
                {/* <Route path="/addsubcategory" element={<AddSubcategory />} /> */}
                <Route path="/products" element={<Products />} />   
                <Route path="/addproducts" element={<AddProducts />} />
                <Route path="/addretailproduct" element={<AddRetailProduct />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/users" element={<Users />} />
                <Route path="/previlage/:employee_id" element={<Previlage />} />
                <Route path="/addusers" element={<Addusers />} />
                <Route path="/editusers/:user_id" element={<Editusers />} />
                <Route path="/stock" element={<Stock />} />
                <Route path="updatelist" element={<UpdateList />} />
                <Route path="updateretaillist" element={<UpdateRetailList />} />
                <Route path="/gstreport" element = {<GstReport />} />
                <Route path="/gstreportpurchase" element = {<GstReportPurchase />} />
                <Route path="/brand" element ={<Brand />} />
                <Route path="/editbrand/:brand_id" element ={<EditBrand />} />
                <Route path="/addbrand" element = {<AddBrand />} />
                {/* <Route path="/editmaincategory/:category_id" element = {<EditMaincategory />} />
                <Route path="/editsubcategory/:subcategory_id" element = {<EditSubcategory />} /> */}
                <Route path="/editproducts/:product_id" element = {<EditProducts />} />
                <Route path="/editretailproduct/:product_id" element = {<EditRetailProduct />} />
                <Route path="/editbilldate/:order_id" element = {<EditBillDate />} />
                <Route path="/cancelorder" element = {<CanceOrder />} />
                <Route path="/cancelorderdetails/:order_id" element = {<CancelOrderDetails />} />
                <Route path="/content" element = {<Content />} />
                <Route path="/contentedit" element = {<ContentEdit />} />
                <Route path="/viewcustomer/:user_id" element = {<ViewCustomer />} />
                <Route path="/invoice/:order_id" element = {<Invoice />} />
                <Route path="/estimate_invoice/:order_id" element = {<EstimateInvoice />} />
                <Route path="/customorderlist/:user_id" element = {<CustomOrderList />} />
                <Route path="/customorderdetails/:order_id" element = {<CustomOrderDetails />} />\
                <Route path="/pos" element = {<Pos />} />
                <Route path="/estimate" element = {<Estimate />} />
                <Route path="/posretailadd" element = {<PosRetailAdd />} />
                {/* <Route path="/gstbill" element = {<GstBill />} /> */}
                {/* <Route path="/gstbill_list" element = {<GstBillList />} /> */}
                <Route path="/paymentpending" element = {<PaymenyPending />} />
                <Route path="/retailproduct" element = {<RetailProduct />} />
                <Route path="/retailpos" element = {<RetailPOS />} />
                <Route path="/supplierpending" element = {<SupplierPending />} />
                <Route path="/paid_report" element = {<PaidReport />} />
                <Route path="/paidprint/:order_id/:paid_id" element = {<PaidPrint />} />
                <Route path="/paidprintsupplier/:order_id/:paid_id" element = {<PaidPrintSupplier />} />
                <Route path="/paid_report_supplier" element = {<PaidReportSupplier />} />
                <Route path="/purchaselist" element = {<PurchaseList />} /> 
                <Route path="/addpurchase" element = {<AddPurchase />} />             
                <Route path="/editpurchase/:order_id" element = {<EditPurchase />} />
                <Route path="/importproducts" element = {<ImportProducts />} />
                <Route path="/importretailproduct" element = {<ImportRetailProduct />} />
                <Route path="/importcustomer" element = {<ImportCustomer />} />
                <Route path="/addcustomer" element = {<AddCustomer />} />
                <Route path="/unit" element ={<Unit />} />
                <Route path="/addunit" element={<AddUnit />} />
                <Route path="/editunit/:unit_id" element={<EditUnit />} />
                <Route path="/supplier" element={<Supplier />} />
                <Route path="/paymentdetails" element={<PaymentDetails />} />
                <Route path="/addpaymentdetails" element={<AddPaymentDetails />} />
                <Route path="/addsupplier" element={<AddSupplier />} />
                <Route path="/editsupplier/:id" element={<EditSupplier />} />
                <Route path="/purchasedetails/:order_id" element={<PurchaseDetails />} />
            </Routes>
            {!isLoginPage &&!isEditEstimateDetails &&!isInvoiceEstimatePage &&!isEstimatePage &&!isPosRetailAddPage &&!isEditRetailOrderDetails &&!isEditOrderDetails &&!ispaidPrintSupplier &&!ispaidPrint &&!isInvoicePage && !isPosPage &&  <Footer />}
        </div>
    );
};

const App = () => {
    return (
        <BrowserRouter basename="/">
            <AppLayout />
        </BrowserRouter>
    );
};

export default App;
